import { render, staticRenderFns } from "./FTooltip.vue?vue&type=template&id=7872b2c6&"
import script from "./FTooltip.vue?vue&type=script&lang=ts&"
export * from "./FTooltip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports